<template>
	<div v-click-outside="onClickOutside">
		<div>
			<label class="uk-width-1-1 uk-position-relative event-filter-label">
				<input @click="toggleDropdown"
					   readonly class="uk-form-small uk-input uk-width-1-1 uk-text-medium"
					   :placeholder="$t('filters.' + filterIndex)"
					   :value="activeFilters[filterId] ? activeFilters[filterId].length + ' selected' : null">
				<span uk-icon="chevron-down" :class="{ 'uk-text-link uk-icon-rotate': isDropdownOpen }"
					  class="uk-position-absolute uk-position-center-right uk-margin-xsmall-right uk-icon"></span>
			</label>
		</div>
		<div class="uk-position-relative">
			<div class="uk-width-1-1 uk-dropdown uk-dropdown-scroll"
				 v-if="isDropdownOpen">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
    import vClickOutside from "v-click-outside";

	export default {
        name: "Dropdown-checkboxes",
		props: [
			'activeFilters', 'filterIndex', 'filterId'
		],
		directives: {
			clickOutside: vClickOutside.directive
		},
		data() {
			return {
				isDropdownOpen: false
			}
		},
		methods: {
			onClickOutside() {
				this.isDropdownOpen = false
			},
			toggleDropdown() {
				this.isDropdownOpen = !this.isDropdownOpen
			}
		},
    }
</script>

<style lang="scss">
	//.uk-dropdown {
	//	display: block;
	//}
</style>
